import { useEffect } from 'react'

/**
 * Shim for the Supabase OAuth redirect bug where the provider returns tokens
 * at `/#access_token=...` instead of the configured `/auth/callback#...`.
 * Delegates the URL rewrite to `normalizeRootHashToCallback` in the service-layer
 * package (kept lazy-imported to avoid pulling Supabase into the initial bundle).
 */
export function useSupabaseRootHashNormalize(): void {
  useEffect(() => {
    if (typeof window === 'undefined') return
    import('@appic/service-layer').then(({ normalizeRootHashToCallback }) => {
      const next = normalizeRootHashToCallback({
        pathname: window.location.pathname,
        search: window.location.search,
        hash: window.location.hash,
      })
      if (next) {
        window.location.replace(next)
      }
    })
  }, [])
}
